module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bloodyMarry@2x_4db3d0.jpg";